import React from 'react';
import './AtualizeSeusDados.css';
import { track } from '../../services/analytics';

export const Section: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => (
  <section className={`atualize-container ${className || ''}`}>
    {children}
  </section>
);

export const Grid: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => (
  <div className={`central-grid ${className || ''}`}>
    {children}
  </div>
);

export const Heading: React.FC<{ level: 1 | 2 | 3; children: React.ReactNode }> = ({ level, children }) => {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  return <Tag className="heading">{children}</Tag>;
};

export const Paragraph: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="paragraph">{children}</p>
);

export const Button: React.FC<{ href: string; label: string }> = ({ href, label }) => (
  <a
    href={href}
    className="atualize-update-button"
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => track('home_menu_clique', {
      identificador: 'atualizar_dados',
      tipo_destino: 'url',
    })}
  >
    {label}
  </a>
);

export const ImageWithDecor: React.FC<{ src: string; alt: string }> = ({ src, alt }) => (
  <div className="atualize-image-area">
    <img src={src} alt={alt} />
  </div>
);

export const ImageArea: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="central-column--image">
		{children}
	</div>
);

export const ContentArea: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="central-column--content">
		{children}
	</div>
);
